import { MomentDateAdapter, MatMomentDateAdapterOptions } from "@angular/material-moment-adapter";
import { Moment } from "moment";
import { Optional, Inject, Injectable } from "@angular/core";
import { MAT_DATE_LOCALE } from "@angular/material";

@Injectable()
export class CustomDateAdapter extends MomentDateAdapter {
    constructor(@Optional() @Inject(MAT_DATE_LOCALE) dateLocale: string) {
        super(dateLocale, { useUtc: true });
    }

    parse(value: any, parseFormat: string | string[]): Moment | null {
        if (parseFormat === 'dateInput') {
            const data: string = localStorage.getItem("dateFormat");
            const json = JSON.parse(data || '{}');
            parseFormat = json[parseFormat] || parseFormat;
        }
        return super.parse(value, parseFormat);
    }

    format(date: Moment, displayFormat: string): string {
        const data: string = localStorage.getItem("dateFormat");
        const json = JSON.parse(data || '{}');
        displayFormat = json[displayFormat] || displayFormat;
        return super.format(date, displayFormat);
    }
}
